import { decode } from 'html-entities';

import { noAvatar, profileImgDefault } from 'assets';
import { ERHIntegrationType } from 'constants/enums';
import store from 'store/storeConfig';
import { getShortPatientGender } from 'utils/ProfileStoreFunctions';

export const formatPatient = (patient: any) => {
  try {
    const { groups } = store.getState();
    const { intl } = store.getState();
    const displayNames = groups.displayNames || [];
    const avatars = groups.avatars || [];

    const gid = patient?.gid;
    const subgroupGid = patient?.subgroup_gid;
    const programs =
      groups.carePrograms.find((x: IGroupCarePrograms) => x.gid === subgroupGid)?.programs || [];
    const groupAdmins: IAdmin[] = groups.groupAdmins.data.filter((admin: IAdmin) =>
      admin.roles.some((role) => [gid, subgroupGid].includes(role.gid))
    );
    const patientCareProgram = programs.filter((x: any) =>
      patient.patientCareProgram?.includes(x.cpid)
    );
    const EHRIntegrationType =
      patient.emr_source_name === 'autoCreateEmrRecord'
        ? ERHIntegrationType.ONE_WAY
        : patient.emr_source_name
          ? ERHIntegrationType.TWO_WAY
          : ERHIntegrationType.NONE;
    const formattedPatient: IPatient = {
      uid: patient.uid,
      firstName: patient.firstName,
      lastName: patient.lastName,
      age: patient.age,
      genderId: patient.gender,
      gender: getShortPatientGender(patient.gender),
      alternateId: patient.alternateId,
      birthday: patient.birthday,
      // This builder is a whitelist: a field absent here never reaches the store however well
      // the API serves it.
      migrationStatus: patient.migrationStatus ?? null,
      migrationStatusSince: patient.migrationStatusSince,
      doctor_in_charge: patient.doctor_in_charge,
      username: patient.username || patient.email, // name of the column in db - see XTC-1841 & XTC-1846
      email_address: patient.email_address,
      pregnancy_due_date: patient.pregnancy_due_date,
      primaryPhoneNumber: patient.primaryPhoneNumber,
      MobilePhoneNumber: patient.MobilePhoneNumber,
      preferredLanguage: patient.locale,
      EHRIntegrationType,
      assignedTo:
        patient.assignedTo?.map((aid: string) => {
          const admin = groupAdmins.find((admin: IAdmin) => admin.aid === aid);
          if (admin) {
            return {
              label: admin?.name || '',
              value: admin?.aid || '',
              icon: avatars[aid] || profileImgDefault
            };
          } else {
            const removed = '(' + intl.messages.removedKey + ')';
            return {
              label: displayNames[aid] ? displayNames[aid] + ' ' + removed : removed,
              value: aid,
              icon: profileImgDefault
            };
          }
        }) || [],
      payer: decode(patient.payer),
      avatar: patient.avatar || noAvatar,
      gid: gid,
      subgroup_gid: patient.subgroup_gid,
      patientNotes: patient.patientNotes,
      address: patient.address,
      lastShippingAddress: patient.lastShippingAddress ?? null,
      npi: patient.npi,
      appVersionKey: patient.appVersionKey,
      tags:
        patient.tags?.map((tag: { tag_id: string }) => {
          return {
            value: tag.tag_id || ''
          };
        }) || [],
      conditions: patient.conditions || [],
      primaryRpmReason: patient.primaryRpmReason,
      secondaryRpmReason: patient.secondaryRpmReason,
      profile: patient.profile,
      logTypes: patient.logTypes,
      joined_date: patient.joined_date,
      patientStatus: patient.patientStatus,
      patientStatusSince: patient.patientStatusSince,
      patientCareProgram: patientCareProgram,
      ssn: patient.ssn,
      otherMedicalInfo: decode(patient.otherMedicalInfo),
      daysWithObservations: parseInt(patient.daysWithObservations) || 0,
      medicalTransmissionDaysWithObservations:
        parseInt(patient.medicalTransmissionDaysWithObservations) || 0,
      billingStartDate: patient.billingStartDate || undefined,
      patientDuplicateThreadMessagesToSMS: patient.patientDuplicateThreadMessagesToSMS,
      smsOptOut: patient.smsOptOut
    };
    return formattedPatient;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
